// GENERATED by tooling/spec-tools/generate-employment-types.mjs — DO NOT EDIT.
// Source of truth: docs/specs/v1/18-hris.yaml `Employee.employment_type`.
// Regenerate with `pnpm employment:gen`; `pnpm employment:check` fails the
// build on drift, and it also pins both CHECK constraints in migration 0034.
//
// The ONE employment-type set. The request schema, the web picker and the
// database CHECK all read from here, so a value one of them accepts is a value
// the others accept — the drift that made `advisor` answer 500 (SEM-6786) has
// no place left to live.

export const EMPLOYMENT_TYPES = [
  "full_time",
  "part_time",
  "intern",
  "temporary",
  "contractor",
  "seasonal",
] as const;

export type EmploymentType = (typeof EMPLOYMENT_TYPES)[number];
